export default "__VITE_ASSET__t5RZlHgG__"